<template>
	<div class="fuel container-fluid py-1 px-0">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12">

				<div class="row">
					<div class="col-md-4 mb-4">
						<PiechartOutstandingCardview :title="'DELIVERED (YTD)'" :status="'Delivered'" :charttypedefault="'piechart'"/>
					</div>
					<div class="col-md-4 mb-4">
						<PiechartOutstandingCardview :title="'OUTSTANDING (YTD)'" :status="'Outstanding'" :charttypedefault="'barchart'"/>
					</div>
					<div class="col-md-4 mb-4">
						<PiechartOutstandingCardview :title="'DELETED (YTD)'" :status="'Deleted'" :charttypedefault="'piechart'"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 mb-4">
						<DOOutstandingTopTenByStation />
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-4 mb-4" v-if="false">
						<DOOutstandingPerArea />
					</div>
					<div class="col-md-4 mb-4">
						<DOOutstandingPerRegion />
					</div>
					<div class="col-md-4 mb-4">
						<DOOutstandingPerProduct />
					</div>
					<div class="col-md-4 mb-4">
						<DOOutstandingPerStationType />
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-6 mb-4">
						<DOOutstandingAllStatusByArea />
					</div>

					<div class="col-md-6 mb-4">
						<DOOutstandingAllDeliveredStatusByArea />
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-4">
						<DOOutstandingAllStatusByRegion />
					</div>

					<div class="col-md-6 mb-4">
						<DOOutstandingAllDeliveredStatusByRegion />
					</div>
				</div>

			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import DOOutstandingPerArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingPerArea.vue'
import DOOutstandingPerRegion from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingPerRegion.vue'
import DOOutstandingPerProduct from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingPerProduct.vue'
import DOOutstandingPerStationType from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingPerStationType.vue'
import DOOutstandingAllStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllStatusByArea.vue'
import DOOutstandingAllStatusByRegion from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllStatusByRegion.vue'
import PiechartOutstandingCardview from '@/views/pages/Fuel/DOOutstanding/Component/PiechartOutstandingCardview.vue'
import DOOutstandingTopTenByStation from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingTopTenByStation.vue'
import DOOutstandingAllDeliveredStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllDeliveredStatusByArea.vue'
import DOOutstandingAllDeliveredStatusByRegion from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllDeliveredStatusByRegion.vue'

export default{
	extends: Fuel,
	components:{
		DOOutstandingPerArea,
		DOOutstandingPerProduct,
		DOOutstandingPerStationType,
		DOOutstandingAllStatusByArea,
		PiechartOutstandingCardview,
		DOOutstandingTopTenByStation,
		DOOutstandingAllDeliveredStatusByArea,

		DOOutstandingPerRegion,
		DOOutstandingAllStatusByRegion,
		DOOutstandingAllDeliveredStatusByRegion,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		Footer            
	},
	data() {
		return {
            value: 0,
			isChildRoute: false,
		}
	},
	watch: {
		$route(to, from) {
            this.hideNonChildren();
        }
	}, 
	computed: {

	},

    mounted() {
        this.$emit('childrenRoute');
		this.hideNonChildren();
    },
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/fuel/do-outstanding';
        },
	}
}
</script>


<style>

  </style>